<template>
  <div
    v-if="brand.logo"
    :class="componentSizeClasses"
  >
    <ImgView
      :img-classes="imageClasses"
      :src="brand.logo"
      :alt="imageAlt"
    />
  </div>
</template>

<script lang="ts">

import type { BrandInfo } from '~~/constants/brands';

export const ALLOWED_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
} as const;
export type BrandImageSize = ValueOf<typeof ALLOWED_SIZES>;

export default defineComponent({
  name: 'BrandImage',

  props: {
    brand: {
      type: Object as PropType<BrandInfo>,
      required: true,
    },
    size: {
      type: String as PropType<BrandImageSize>,
      default: ALLOWED_SIZES.SMALL,
      validator: (value: unknown): boolean => {

        return Object.values(ALLOWED_SIZES).includes(value as BrandImageSize);
      
      },
    },
  },
  setup(props) {

    const classesForSize = {
      [ALLOWED_SIZES.SMALL]: 'w-32 h-16',
      [ALLOWED_SIZES.MEDIUM]: 'w-72 h-32',
    };
    const imageClasses = computed(() => {

      return `${classesForSize[props.size]} object-contain`;
    
    });
    const componentSizeClasses = computed(() => {

      return classesForSize[props.size];
    
    });
    const imageAlt = computed(() => {

      return `${props.brand.name} logo`;
    
    });

    return {
      componentSizeClasses,
      imageClasses,
      imageAlt,
    };
  
  },
});

</script>
